// Date utility functions
import { resolveIntlLocale } from './locale';

/**
 * Format a date as relative time
 * @param {Date} date - The date to format
 * @returns {string} Formatted relative time string
 */
export function formatRelativeTime(date, locale, t) {
  const resolvedLocale = resolveIntlLocale(locale);
  const parsedDate = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(parsedDate.getTime())) {
    return t ? t('common.notAvailable') : 'N/A';
  }

  const now = new Date();
  const diffMs = now - parsedDate;
  const diffMins = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMins < 1) {
    return t ? t('common.relativeTime.justNow') : 'Just now';
  }

  if (diffMins < 60) {
    if (t) {
      return t('common.relativeTime.minutesAgo', { count: diffMins });
    }
    return new Intl.RelativeTimeFormat(resolvedLocale, { numeric: 'always' }).format(-diffMins, 'minute');
  }

  if (diffHours < 24) {
    if (t) {
      return t('common.relativeTime.hoursAgo', { count: diffHours });
    }
    return new Intl.RelativeTimeFormat(resolvedLocale, { numeric: 'always' }).format(-diffHours, 'hour');
  }

  if (diffDays < 7) {
    if (t) {
      return t('common.relativeTime.daysAgo', { count: diffDays });
    }
    return new Intl.RelativeTimeFormat(resolvedLocale, { numeric: 'always' }).format(-diffDays, 'day');
  }

  // For older dates, use formatted date
  return new Intl.DateTimeFormat(resolvedLocale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(parsedDate);
}

